export default __webpack_public_path__ + "static/media/bed2054img.91579ff7.jpg";